<div class="modal" tabindex="-1" role="dialog" #modalCancelled>
  <form
    (submit)="save()"
    [formGroup]="formStatusCancelled"
    (keydown.enter)="save()"
    class="main-form"
    >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" [innerText]="'ENQUIRIES.CANCELLED_ENQUIRY' | translate"></h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            [attr.aria-label]="'GENERAL.CLOSE' | translate"
          ></button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label for="reason" [innerText]="'ENQUIRIES.REASON_CANCELLED' | translate"></label>
            <select
              class="form-select"
              id="reason"
              formControlName="reason"
              required
              [class.is-invalid]="
                (formStatusCancelled.touched || formStatusCancelled.controls['reason'].touched) &&
                formStatusCancelled.controls['reason'].status === 'INVALID'
                  ? 'danger'
                  : ''
              "
              >
              <option [ngValue]="null" [innerText]="'GENERAL.PLEASE_SELECT_ONE' | translate"></option>
              @for (reason of getCancelledReasons(); track reason) {
                <option
                  [value]="reason"
                  [innerText]="getEnumEnquiryCancelledReasonLabel(reason) | translate"
                ></option>
              }
            </select>

            <div class="invalid-tooltip">
              @if (
                (formStatusCancelled.touched || formStatusCancelled.controls['reason'].touched) &&
                formStatusCancelled.controls['reason'].errors &&
                formStatusCancelled.controls['reason'].errors['required']
                ) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          </div>

          <div class="form-group">
            <label for="comment" [innerText]="'ENQUIRIES.CANCEL_COMMENT' | translate"></label>
            <textarea
              formControlName="comment"
              class="form-control"
              id="comment"
              [class.is-invalid]="
                (formStatusCancelled.touched || formStatusCancelled.controls['comment'].touched) &&
                formStatusCancelled.controls['comment'].status === 'INVALID'
                  ? 'danger'
                  : ''
              "
            ></textarea>

            <div class="invalid-tooltip">
              @if (
                (formStatusCancelled.touched || formStatusCancelled.controls['comment'].touched) &&
                formStatusCancelled.controls['comment'].errors &&
                formStatusCancelled.controls['comment'].errors['required']
                ) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
            [innerText]="'GENERAL.CANCEL' | translate"
          ></button>
          <button
            type="button"
            class="btn btn-primary"
            (click)="save()"
            [disabled]="formStatusCancelled.disabled || !formStatusCancelled.valid"
            [innerText]="'GENERAL.SAVE' | translate"
          ></button>
        </div>
      </div>
    </div>
  </form>
</div>
